import {useCallback} from 'react';
import {TaskListRowProps} from '../../../constants/types';
import dayjs from 'dayjs';
import {Link} from 'react-router-dom';
import EnsurePermission from '../../common/EnsurePermission';
import {Button} from '../../common/Button';
import {dateFormat, processesNames} from '../../../constants/constants';
import permissionsInfo from '../../../constants/permissionsInfo';
import routes from '../routes';
import {TaskToClaim} from '../types';

type RowProps = {
  id: number,
  rowItem: TaskListRowProps,
  shouldShowClaimButton: boolean,
  handleOpenClaimPopup: (taskDetails: TaskToClaim) => void
}

const TaskListRow = ({
  id, rowItem, shouldShowClaimButton, handleOpenClaimPopup
}: RowProps) => {
  const formattedStartAt = dayjs(rowItem.startedAt)
      .format(dateFormat);
  const formattedTargetTime = dayjs(formattedStartAt)
      .add(rowItem?.targetTime || 0, 's');

  const currentTime = dayjs();
  const isTimeExpired = currentTime > formattedTargetTime;

  const durationAsString = (start, end) => {
    const duration = dayjs.duration(dayjs(end).diff(dayjs(start)));

    const hours = Math.floor(duration.asHours());
    const hoursFormatted = hours ? `${hours}h ` : '';

    const minutes = duration.minutes();
    const minutesFormatted = `${minutes}m`;

    return [hoursFormatted, minutesFormatted].join('')
        .replace(/\-/g, '');
  };

  const handleClaim = useCallback(() => {
    handleOpenClaimPopup({
      id, processId: rowItem?.processId, isClaimed: !!rowItem?.teamMember
    });
  }, [id, rowItem?.processId, rowItem?.teamMember]);

  return (
    <tr className="row">
      <td className="cell">
        <Link to={routes.item(rowItem?.processId)} className="link" title={rowItem.taskName}>
          {rowItem.taskName}
        </Link>
      </td>
      <td className="cell">
        <Link
          to={`/processes/running/${rowItem?.processId}`}
          className="link">
          {processesNames[rowItem?.processName?.code || 'SCHEDULING'] || ''}
        </Link>
      </td>
      <td className="cell">{rowItem?.groups}</td>
      <td className="cell">{!!rowItem?.startedAt &&
        dayjs(rowItem?.startedAt).format(dateFormat)}
      </td>
      <td className="cell">
        {!!rowItem?.startedAt &&
        <>
          <span>{durationAsString(formattedStartAt, currentTime)}</span>
          /
          <span className={`expired-time ${isTimeExpired ? 'red' : 'green'}`}>
            &nbsp;{`${isTimeExpired ? '+' : '-'}
            ${durationAsString(formattedTargetTime, currentTime)}`}
          </span>
        </>}
      </td>
      <td className="cell">{rowItem?.operatoryNumber}</td>
      <td className="cell">{rowItem?.teamMember}</td>
      <EnsurePermission elementPermissions={permissionsInfo.tasks.claim}>
        <td className="cell narrow-cell">
          {shouldShowClaimButton && (
            <Button
              label="Claim"
              variant="text"
              size="small"
              className="cell-claim"
              onClick={handleClaim}
            />
          )}
        </td>
      </EnsurePermission>
    </tr>
  );
};

export default TaskListRow;
